// extracted by mini-css-extract-plugin
export default {"descriptionsWrapper":"DescriptionWrapper_descriptionsWrapper__cmLoC"};